// extracted by mini-css-extract-plugin
export default {"container":"Board_container__X3DFX"};